module.exports = __webpack_public_path__ + "img/icon_text_bco.bf227ee6.svg";